<template>
  <div class="douplus">
    <div class="top">
      <img
        style="margin: 10px 0; width: 100%; height: 70px"
        src="@/assets/images/simulation/douplus.jpg"
      />
      <van-notice-bar color="#303133" background="#F2F6FC" :scrollable="false">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, idx) in noticeList" :key="idx">
            <div style="overflow: hidden">
              <img
                class="avatar"
                src="https://img01.yzcdn.cn/vant/cat.jpeg"
                alt=""
              />
              <span class="name">{{ item.name }}</span>
              <span class="content">{{ item.content }}</span>
              <span class="time">{{ item.time }}</span>
            </div>
          </van-swipe-item>
          <van-swipe-item>以上数据仅供参考</van-swipe-item>
          <van-swipe-item>投放效果取决于视频内容质量等因素</van-swipe-item>
        </van-swipe>
      </van-notice-bar>

      <div class="video-info">
        <el-image
          style="width: 60px; height: 60px"
          src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"
          fit="cover"
        ></el-image>
        <p class="info-text">#视频名称#我的视频就叫这个#取名字好难哈哈</p>
      </div>

      <div class="s-row">
        <div class="s-item k">
          <span>投放目标</span>
          <van-icon
            class="icon"
            name="question-o"
            color="#909399"
            @click="showTargetTips = true"
          />
          <span class="sel" @click="showTarget = true">
            <span>{{ form.target }}</span>
            <van-icon class="icon" name="arrow" />
          </span>
        </div>
        <span class="shu">|</span>
        <div class="s-item d">
          <span>投放时长</span>
          <van-icon
            class="icon"
            name="question-o"
            color="#909399"
            @click="handleDuringTips"
          />
          <span class="sel" @click="showDuring = true">
            <span>{{ form.during }}</span>
            <van-icon class="icon" name="arrow" />
          </span>
        </div>
      </div>
    </div>

    <div class="gap"></div>

    <div class="main">
      <p class="m-title">
        把视频推荐给潜在兴趣用户
        <van-icon
          class="icon"
          name="question-o"
          color="#909399"
          @click="handleRecommendTips"
        />
      </p>
      <van-radio-group v-model="form.recommendType">
        <van-radio name="系统智能推荐" checked-color="#ec345c" icon-size="16px"
          >系统智能推荐</van-radio
        >
        <van-radio
          name="自定义定向推荐"
          checked-color="#ec345c"
          icon-size="16px"
          >自定义定向推荐
          <span class="tag">推荐商家使用地域定向</span>
        </van-radio>
      </van-radio-group>

      <custom-recommend
        v-show="form.recommendType == '自定义定向推荐'"
        :form="form"
      />

      <p class="m-title">
        <span
          v-show="form.target == '评论链接点击' || form.target == '智能优化'"
          >预计提升的优化次数</span
        >
        <span
          v-show="form.target == '主页浏览量' || form.target == '点赞评论量'"
          >预计带来转化数</span
        >
        <span v-show="form.target == '粉丝量'">预计新增粉丝人数</span>
        <van-icon
          class="icon"
          name="question-o"
          color="#909399"
          @click="handleNumTips"
        />
      </p>

      <p class="tips">预估转化数据仅作为参考</p>
      <div class="num-box">
        <span>{{ minNum }}–{{ maxNum }}</span>
        {{ form.target == "粉丝量" ? "人" : "次" }}
      </div>

      <p class="m-title small">
        投放金额
        <van-icon
          class="icon"
          name="question-o"
          color="#909399"
          @click="handleAmountTips"
        />
      </p>
      <div class="amount-box">
        <span
          class="amount-item"
          :class="{ active: item * 300 == form.amount && !isCustom }"
          v-for="item in 5"
          :key="item"
          @click="
            form.amount = item * 300;
            isCustom = false;
            customAmount = null;
          "
          >￥{{ 300 * item }}</span
        >
        <span
          class="amount-item"
          :class="{ active: isCustom }"
          @click="showCustom = true"
          >{{ isCustom ? "￥" + form.amount : "自定义"
          }}<van-icon name="arrow" v-show="isCustom" size="12"
        /></span>
      </div>
    </div>

    <div class="gap fine"></div>

    <div class="questions">
      <p class="title">常见问题</p>
      <div class="q-item">
        <div class="q">
          <span class="icon">问</span>
          <span class="content"
            >第一次投，选什么目标好啊？哪个大神给指点一下</span
          >
        </div>
        <div class="a">
          <img
            class="avatar"
            src="https://img01.yzcdn.cn/vant/cat.jpeg"
            alt=""
          />
          <span class="content"
            >如果你粉丝比较少，建议你可以先用粉丝量这个目标养粉。然后有了一定的粉丝再把粉丝量和点赞评论量结合着投比较好。选智能推荐量最大。</span
          >
        </div>
      </div>
      <div class="q-item mt" v-show="showS">
        <div class="q">
          <span class="icon">问</span>
          <span class="content">什么时候用DOU+效果最好？</span>
        </div>
        <div class="a">
          <img
            class="avatar"
            src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
            alt=""
          />
          <span class="content"
            >你问的是什么时间还是视频的什么阶段？时间的话其实无所谓，因为热门时间段流量多但竞争的达人也多，所以占不到什么便宜。视频阶段的话我建议你发完视频有了几百播放量，感觉点赞评论还不错的时候投，效果会好一些。</span
          >
        </div>
      </div>

      <p class="more-btn" @click="showS = !showS">
        {{ showS ? "收起" : "查看更多" }}
        <van-icon :name="showS ? 'arrow-up' : 'arrow-down'" />
      </p>
    </div>

    <div class="gap fine"></div>

    <div class="amount">
      <span>投放金额</span>
      <p class="total">
        合计：<span>￥{{ form.amount }}</span>
      </p>
    </div>

    <van-cell
      is-link
      value="无可用优惠卷"
      style="padding: 0 10px 10px"
      @click="showCoupon = true"
    >
      <template #title>
        <van-icon name="coupon-o" color="#ec345c" size="16" />
        <span class="custom-title">优惠卷</span>
      </template>
    </van-cell>

    <p class="agreement">
      点击支付则视为同意
      <a
        href="https://doujia.douyin.com/doc/content_promotion"
        target="_blank"
        rel="noopener noreferrer"
        >内容加热服务协议</a
      >
      <template v-if="form.target == '点赞评论量' || form.target == '粉丝量'">
        和
        <a
          href="https://doujia.douyin.com/doc/ad_promotion"
          target="_blank"
          rel="noopener noreferrer"
          >数据推广服务协议</a
        ></template
      >
    </p>

    <div class="fix-bottom">
      <span style="color: #ec345c"
        >￥<span class="amount">{{ form.amount }}</span></span
      >
      <span class="pay-btn" @click="handleSubmit">拼手气支付</span>
    </div>

    <van-popup
      v-model="showTarget"
      round
      position="bottom"
      :style="{ height: '46%' }"
    >
      <div class="p-head">
        <span class="btn q" @click="showTarget = false">取消</span>
        <span class="title">投放目标</span>
        <span
          class="btn w"
          @click="
            form.target = target;
            showTarget = false;
          "
          >完成</span
        >
      </div>
      <div class="p-main">
        <div
          class="target-item"
          :class="{ active: item == target }"
          v-for="(item, idx) in targetList"
          :key="idx"
          @click="target = item"
        >
          {{ item }}
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showDuring" round position="bottom">
      <van-picker
        show-toolbar
        title="投放时长"
        :columns="duringList"
        :visible-item-count="5"
        :default-index="5"
        @cancel="showDuring = false"
        @confirm="onConfirm"
        @change="handleChange"
      >
        <span slot="confirm" style="color: #ec345c">确认</span>
      </van-picker>
      <p class="money-tips">
        投放<span>{{ during }}</span
        >，最低投放金额为<span>{{ money }}</span
        >元
      </p>
    </van-popup>

    <van-popup
      v-model="showTargetTips"
      style="background-color: transparent; overflow: inherit"
    >
      <div class="swipe-box">
        <van-icon
          v-show="current != 0"
          class="swipe-arrow prev"
          name="arrow-left"
          color="#fff"
          size="25"
          @click="$refs.swipe.prev()"
        />
        <van-swipe
          class="my-swipe"
          ref="swipe"
          indicator-color="white"
          @change="onChange"
        >
          <van-swipe-item v-for="(item, idx) in swipeList" :key="idx">
            <div class="swipe-item">
              <div style="padding: 10px; height: 265px">
                <el-image class="cover" :src="item.cover" fit="fit"></el-image>
                <p class="swipe-item-title">{{ item.title }}</p>
                <p class="swipe-item-content">
                  {{ item.content }}
                </p>
              </div>
              <p class="swipe-item-btn" @click="showTargetTips = false">
                我知道了
              </p>
            </div>
          </van-swipe-item>
        </van-swipe>
        <van-icon
          v-show="current != 5"
          class="swipe-arrow next"
          name="arrow"
          color="#fff"
          size="25"
          @click="$refs.swipe.next()"
        />
      </div>
    </van-popup>

    <van-popup v-model="showCustom">
      <div class="custom-amount-popup">
        <van-icon
          class="close-icon"
          name="clear"
          size="18"
          color="#909399"
          @click="showCustom = false"
        />
        <h3>自定义金额</h3>
        <el-input v-model="customAmount" placeholder="￥请输入金额"></el-input>
        <p class="tips">投放金额最少100元</p>
        <div class="s-btn" :class="{ disabled }" @click="handleCustom">
          确定
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showCoupon" round position="bottom">
      <van-picker
        readonly
        show-toolbar
        title="选择优惠卷"
        :columns="['无可用优惠卷']"
        :visible-item-count="5"
        @cancel="showCoupon = false"
        @confirm="showCoupon = false"
      >
        <span slot="confirm" style="color: #ec345c">确认</span>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import customRecommend from "./customRecommend.vue";
import "vant/lib/index.css";
import {
  NoticeBar,
  Swipe,
  SwipeItem,
  Icon,
  Popup,
  Picker,
  Dialog,
  RadioGroup,
  Radio,
  Cell,
} from "vant";
import { submit } from "@/api/chapterMock";
export default {
  components: {
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    customRecommend,
  },
  data() {
    return {
      noticeList: [
        {
          avatar: "",
          name: "罗*哥",
          content: "投放200元，获得1183个粉丝",
          time: "10小时前",
        },
        {
          avatar: "",
          name: "老*林",
          content: "投放100元，获得312个点赞评论",
          time: "17小时前",
        },
        {
          avatar: "",
          name: "孙*正",
          content: "投放100元，获得3109个粉丝",
          time: "22小时前",
        },
      ],
      form: {
        target: "评论链接点击",
        during: "3天",
        recommendType: "系统智能推荐",
        amount: 300,
        sex: "不限",
        age: [],
        address: [],
        interest: [],
        talent: "不限",
      },
      targetList: [
        "评论链接点击",
        "智能优化",
        // "线索量",
        "主页浏览量",
        "点赞评论量",
        "粉丝量",
      ],
      duringList: ["2小时", "6小时", "12小时", "24小时"],
      showTarget: false,
      target: "评论链接点击",
      showDuring: false,
      during: "3天",
      money: 100,
      showTargetTips: false,
      current: 0,
      swipeList: [
        {
          cover: require("@/assets/images/simulation/target1.jpg"),
          title: "评论链接点击",
          content:
            "增加评论区置顶链接的点击量，可以获取更多客户线索，并将视频曝光给更多潜在客户。",
        },
        {
          cover: require("@/assets/images/simulation/target2.jpg"),
          title: "智能优化",
          content:
            "智能优化目标将根据视频内容，由系统智能筛选，推荐给最合适的人群进行加热展示。",
        },
        {
          cover: require("@/assets/images/simulation/target3.jpg"),
          title: "线索量",
          content:
            "你可通过设置的组件展示想推广的产品或服务，吸引潜在客户留资。",
        },
        {
          cover: require("@/assets/images/simulation/target4.jpg"),
          title: "主页浏览量",
          content:
            "对你视频感兴趣的用户，将进入你的个人主页，观看更多精彩内容。",
        },
        {
          cover: require("@/assets/images/simulation/target5.jpg"),
          title: "点赞评论量",
          content:
            "用户通过对你的视频进行点赞/评论/分享/点击个人主页等方式与你进行互动。",
        },
        {
          cover: require("@/assets/images/simulation/target4.jpg"),
          title: "粉丝量",
          content: "对你视频感兴趣的用户，产生的关注行为",
        },
      ],
      showRecommend: false,
      isCustom: false,
      showCustom: false,
      customAmount: null,
      showS: false,
      showCoupon: false,
    };
  },
  created() {
    let arr = [];
    for (let i = 2; i <= 30; i++) {
      arr.push(`${i}天`);
    }
    this.duringList = [...this.duringList, ...arr];
  },
  computed: {
    minNum() {
      return ((this.form.amount / 100) * 17).toFixed(0);
    },
    maxNum() {
      return ((this.form.amount / 100) * 33).toFixed(0);
    },
    disabled() {
      let val = Number(this.customAmount);
      if (typeof val == "number" && val >= 100) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    onConfirm(val) {
      this.form.during = val;
      this.showDuring = false;
    },
    handleChange(picker, val, idx) {
      this.during = val;
      if (idx <= 5) {
        this.money = 100;
      } else if (idx <= 7) {
        this.money = 300;
      } else if (idx <= 12) {
        this.money = parseInt(val) * 60;
      } else {
        this.money = parseInt(val) * 70;
      }
    },
    onChange(index) {
      this.current = index;
    },
    handleDuringTips() {
      Dialog.alert({
        title: "投放时长",
        width: 275,
        message:
          "长周期投放的X天数是指X*24小时；此投放时长为预估时长，订单以实际消耗情况为准",
        confirmButtonText: "我知道了",
        confirmButtonColor: "#303133",
        closeOnClickOverlay: true,
        className: "time-dialog",
      }).then(() => {
        // on close
      });
    },
    handleRecommendTips() {
      Dialog.alert({
        title: "把视频推荐给潜在兴趣用户",
        width: 275,
        message: "将视频展现给推荐流更多潜在兴趣用户，提升视频的播放量",
        confirmButtonText: "关闭",
        confirmButtonColor: "#303133",
        closeOnClickOverlay: true,
        className: "time-dialog",
      }).then(() => {
        // on close
      });
    },
    handleNumTips() {
      let title =
        this.form.target == "粉丝量" ? "预计新增粉丝人数" : "预计带来的转化数";
      let str = this.form.target == "粉丝量" ? "涨粉人数" : "转化次数";
      Dialog.alert({
        title,
        width: 275,
        message: `系统会根据投放设置实时预估${str}`,
        confirmButtonText: "我知道了",
        confirmButtonColor: "#303133",
        closeOnClickOverlay: true,
        className: "time-dialog",
      }).then(() => {
        // on close
      });
    },
    handleAmountTips() {
      Dialog.alert({
        title: "投放金额",
        width: 275,
        message:
          "投放金额为此次投放的最大消耗值，系统会尽可能100%投放完成。但投放过程中若遇到如视频删除/设好友可见或私密/人工举报/投放效率不佳，系统会自动结束投放。剩余未消耗的金额将3~48小时可退回到DOU+账户",
        messageAlign: "left",
        confirmButtonText: "关闭",
        confirmButtonColor: "#303133",
        closeOnClickOverlay: true,
        className: "time-dialog",
      }).then(() => {
        // on close
      });
    },
    // 自定义金额
    handleCustom() {
      if (this.disabled) return;
      this.isCustom = true;
      this.form.amount = this.customAmount;
      this.showCustom = false;
    },
    // 提交
    handleSubmit() {
      Dialog.confirm({
        title: "提示",
        message: "确认提交内容？",
      }).then(() => {
        const classChapterId = localStorage.getItem("mockChapterId");
        submit({
          classChapterId,
          content: JSON.stringify(this.form),
        }).then((res) => {
          Dialog.alert({
            title: "提示",
            message: "提交完成",
          }).then(() => {
            window.close();
            window.parent.close();
          });
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.douplus {
  padding-bottom: 40px;
  height: 660px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  .top {
    padding: 0 10px;
    .notice-swipe {
      padding: 0 10px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      .avatar {
        margin-right: 10px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        vertical-align: -6px;
      }
      .time {
        float: right;
        color: #909399;
      }
    }
    .video-info {
      margin: 20px 0;
      .info-text {
        display: inline-block;
        margin-left: 10px;
        width: calc(100% - 60px - 10px);
        color: #333;
        font-weight: bold;
        vertical-align: top;
      }
    }
    .s-row {
      padding: 0 0 20px;
      .s-item {
        display: inline-block;
        &.k {
          width: 52%;
          .sel {
            width: 57%;
          }
        }
        &.d {
          width: 40%;
          .sel {
            width: 43%;
          }
        }
        .icon {
          margin-left: 3px;
          cursor: pointer;
        }
        .sel {
          display: inline-block;
          font-size: 12px;
          text-align: right;
          color: #ec345c;
          cursor: pointer;
        }
      }
      .shu {
        margin: 0 10px;
        color: #c0c4cc;
      }
    }
  }
  .gap {
    width: 100%;
    height: 15px;
    background-color: #f2f6fc;
    &.fine {
      height: 10px;
    }
  }

  .main {
    padding: 20px 10px;
    .icon {
      margin-left: 3px;
      cursor: pointer;
    }
    .m-title {
      margin-bottom: 15px;
      &.small {
        margin-bottom: 10px;
        font-size: 12px;
      }
    }
    ::v-deep .van-radio {
      margin-bottom: 15px;
      .van-radio__label {
        font-size: 12px;
      }
      .tag {
        display: inline-block;
        padding: 0 3px;
        font-size: 12px;
        color: rgb(192, 141, 31);
        background-color: rgb(255, 254, 220);
      }
    }
    .tips {
      margin-top: -5px;
      font-size: 12px;
      color: #909399;
    }
    .num-box {
      padding: 40px 0;
      font-weight: bold;
      text-align: center;
      span {
        display: inline-block;
        font-size: 28px;
        color: #ec345c;
        vertical-align: middle;
      }
    }
    .amount-box {
      .amount-item {
        display: inline-block;
        padding: 3px 0;
        margin: 5px;
        width: 30%;
        text-align: center;
        color: #303133;
        border: solid 1px #ebeef5;
        border-radius: 3px;
        cursor: pointer;
        &.active {
          color: #ec345c;
          background-color: rgb(255, 230, 235);
          border-color: rgb(255, 215, 223);
        }
      }
    }
  }

  .questions {
    padding: 20px 10px 0;
    .title {
      margin-bottom: 15px;
    }
    .q-item {
      &.mt {
        margin-top: 25px;
      }
      .q,
      .a {
        .icon,
        .avatar {
          display: inline-block;
          margin-right: 5px;
          width: 18px;
          height: 18px;
          text-align: center;
          border-radius: 50%;
          font-size: 12px;
          color: #fff;
          background: #ec345c;
        }
        .content {
          display: inline-block;
          width: 92%;
          font-size: 12px;
          text-align: justify;
          vertical-align: top;
        }
        &.a {
          margin-top: 10px;
          .content {
            color: #909399;
          }
        }
      }
    }
    .more-btn {
      margin: 10px 0;
      color: #909399;
      text-align: center;
      cursor: pointer;
    }
  }

  .amount {
    padding: 20px 10px;
    overflow: hidden;
    .total {
      float: right;
      span {
        color: #ec345c;
      }
    }
  }
  .custom-title {
    display: inline-block;
    margin-left: 10px;
    font-size: 12px;
    vertical-align: top;
  }

  .agreement {
    padding: 10px;
    font-size: 13px;
    color: #909399;
    a {
      color: darkblue;
    }
  }

  .fix-bottom {
    position: fixed;
    bottom: 0;
    padding: 10px 10px 0;
    width: 100%;
    border-top: solid 1px #e4e7ed;
    background: #fff;
    overflow: hidden;
    .amount {
      font-size: 24px;
      color: #ec345c;
    }
    .pay-btn {
      float: right;
      padding: 6px 8px;
      text-align: center;
      color: #fff;
      background: #ec345c;
      border-radius: 3px;
      cursor: pointer;
    }
  }

  .p-head {
    padding: 16px;
    text-align: center;
    border-bottom: solid 1px #ebeef5;
    overflow: hidden;
    .title {
      font-weight: bold;
      font-size: 16px;
    }
    .btn {
      cursor: pointer;
      &.q {
        float: left;
      }
      &.w {
        float: right;
        color: #ec345c;
      }
    }
  }
  .p-main {
    padding: 5px 16px;
    .target-item {
      padding: 7px 0;
      margin: 10px 0;
      border-radius: 4px;
      border: solid 1px #ebeef5;
      text-align: center;
      cursor: pointer;
      &.active {
        background-color: rgb(255, 230, 235);
        border-color: rgb(255, 215, 223);
      }
    }
  }
  .money-tips {
    margin-top: 10px;
    text-align: center;
    color: #909399;
    span {
      color: #303133;
      margin: 0 5px;
      font-weight: bold;
    }
  }

  .swipe-box {
    position: relative;
    width: 250px;
    .swipe-arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      &.prev {
        left: -40px;
      }
      &.next {
        right: -40px;
      }
    }
    .my-swipe {
      padding-bottom: 30px;
      cursor: default;
      .van-swipe-item {
        .swipe-item {
          text-align: center;
          background-color: #fff;
          .cover {
            width: 100%;
            height: 120px;
          }
          .swipe-item-title {
            margin: 15px 0;
            font-size: 16px;
            font-weight: bold;
          }
          .swipe-item-content {
            margin-bottom: 20px;
            color: #606266;
            font-size: 13px;
          }
          .swipe-item-btn {
            padding: 10px 0;
            border-top: solid 1px #ebeef5;
            font-weight: bold;
            cursor: pointer;
          }
        }
      }
    }
  }

  .custom-amount-popup {
    position: relative;
    padding: 20px;
    width: 250px;
    text-align: center;
    .close-icon {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
    h3 {
      padding: 10px 0;
    }
    .el-input {
      margin: 6px 0;
    }
    .tips {
      font-size: 12px;
      color: #909399;
      text-align: left;
    }
    .s-btn {
      margin-top: 20px;
      padding: 10px 0;
      text-align: center;
      color: #fff;
      background: #ec345c;
      cursor: pointer;
      &.disabled {
        background: #eb7c94;
        cursor: not-allowed;
      }
    }
  }
}
</style>

<style lang="less">
.time-dialog {
  .van-dialog__header,
  .van-button__text {
    color: #303133;
    font-weight: bold;
  }
}
</style>